module.exports = __webpack_public_path__ + "img/one.61e294db.svg";